
import classes from './ErrorMessage.module.css'


const ErrorMessage = ({message}: {message: string}) => {
    return (
        <div>
            <p className={classes.error__message}>{message}</p>
        </div>
    
    
    )
}

export default ErrorMessage